import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'formatDate',
    standalone: false
})
export class FormatDate implements PipeTransform {
    transform(value: any) {
        if (value !== '' && value != null) {
            switch (typeof value) {
                case 'object':
                    if (value instanceof Date) {
                       return moment(value).format('MM/DD/YYYY');
                    }
                    const val = {
                        year: value.year,
                        month: value.month - 1,
                        day: value.day
                    };
                    return moment(val).format('MM/DD/YYYY');
                case 'string':
                    return moment(value).format('MM/DD/YYYY');
                  default:
                    return null;
            }
        } else {
            return '';
        }

    }
}
